
import DA_HOU_001 from './da-hou-001'
import DA_HOU_002 from './da-hou-002'

import DA_HMUL_001 from './da-hmul-001'
import DA_HMUL_002 from './da-hmul-002'
import DA_HMUL_003 from './da-hmul-003'
import DA_HMUL_004 from './da-hmul-004'

import DA_HMUF_001 from './da-hmuf-001'
import DA_HMUF_002 from './da-hmuf-002'
import DA_HMUF_003 from './da-hmuf-003'
import DA_HMUF_004 from './da-hmuf-004'
import DA_HMUF_005 from './da-hmuf-005'
import DA_HMUF_006 from './da-hmuf-006'

import DA_BME_001 from './da-bme-001'
import DA_BME_002 from './da-bme-002'

import DA_HMS_001 from './da-hms-001'
import DA_HMS_002 from './da-hms-002'
import DA_HMS_003 from './da-hms-003'
import DA_HMS_004 from './da-hms-004'
import DA_HMS_005 from './da-hms-005'
import DA_HMS_006 from './da-hms-006'
import DA_HMS_007 from './da-hms-007'
import DA_HMS_008 from './da-hms-008'
import DA_HMS_009 from './da-hms-009'
import DA_HMS_010 from './da-hms-010'
import DA_HMS_011 from './da-hms-011'
import DA_HMS_012 from './da-hms-012'
import DA_HMS_013 from './da-hms-013'

import DA_MME_001 from './da-mme-001'
import DA_MME_002 from './da-mme-002'
import DA_MME_003 from './da-mme-003'
import DA_MME_004 from './da-mme-004'
import DA_MME_005 from './da-mme-005'
import DA_MME_006 from './da-mme-006'
import DA_MME_007 from './da-mme-007'
import DA_MME_008 from './da-mme-008'
import DA_MME_009 from './da-mme-009'
import DA_MME_010 from './da-mme-010'
import DA_MME_011 from './da-mme-011'
import DA_MME_012 from './da-mme-012'

import DA_MMEU_001 from './da-mmeu-001'
import DA_MMEU_002 from './da-mmeu-002'
import DA_MMEU_003 from './da-mmeu-003'


const state = () => ({
  items: {
    DA_HOU_001,
    DA_HOU_002,

    DA_HMUL_001,
    DA_HMUL_002,
    DA_HMUL_003,
    DA_HMUL_004,

    DA_HMUF_001,
    DA_HMUF_002,
    DA_HMUF_003,
    DA_HMUF_004,
    DA_HMUF_005,
    DA_HMUF_006,

    // DA_BME_001,
    // DA_BME_002,

    DA_HMS_001,
    DA_HMS_002,
    DA_HMS_003,
    DA_HMS_004,
    DA_HMS_005,
    DA_HMS_006,
    DA_HMS_007,
    DA_HMS_008,
    DA_HMS_009,
    DA_HMS_010,
    DA_HMS_011,
    DA_HMS_012,
    DA_HMS_013,

    DA_MME_001,
    DA_MME_002,
    DA_MME_003,
    DA_MME_004,
    DA_MME_005,
    DA_MME_006,
    DA_MME_007,
    DA_MME_008,
    DA_MME_009,
    DA_MME_010,
    DA_MME_011,
    DA_MME_012,

    DA_MMEU_001,
    DA_MMEU_002,
    DA_MMEU_003
  }
})

const getters = {
  items: state => state.items
}

export default {
  namespaced: true,
  state,
  getters
}
